var EditProductAlbumView = EditAlbumView.extend({
  /**
   Show the edit product photos form.
   */
  show: function() {
    this.$el.show();
  }
});
